module.exports = __webpack_public_path__ + "static/media/Blackjack.2207f044.webp";